"use client";
import type { Props } from "../../types/Code";
import dynamic from "next/dynamic";
import React from "react";

/**
 * Frontiere de chargement paresseux pour prism-react-renderer (84 ko).
 *
 * L'`import()` doit partir d'un module CLIENT : un `dynamic()` appele depuis un
 * Server Component decoupe les fichiers mais laisse le module dans le groupe de
 * chunks initial de la page, donc tout le monde le telecharge. Ici l'import est
 * cote client, Turbopack en fait un groupe asynchrone charge seulement quand un
 * bloc `code` est reellement rendu.
 */
const CodeHighlight = dynamic(() =>
  import("./CodeHighlight").then((m) => m.CodeHighlight),
);

export const Code: React.FC<Props> = ({ code, language = "" }) => {
  if (!code) return null;
  return <CodeHighlight code={code} language={language} />;
};
